import { ApplicationsState, ConvocatoriasState, FormState } from '@/state'
import ApplicationsTable from '../applications/table'
import ConvocatoriaContainer from './convocatoria'
import RenderFormTabs from '@/components/form-tabs'
import ApplicationsFilters from '../applications/filters'
import { Button, Tooltip } from 'antd'
import { FiRefreshCw } from 'react-icons/fi'
import { applicationsStateActions } from '@/state/actions'
import { OfflineState } from '@/state/offline-management'

import ImportApplications from '../applications/import'
import { BiExport } from 'react-icons/bi'

import './index.scss'

export const HomeContainer: React.FC = () => {
  if (FormState.showForm.value) return <RenderFormTabs />

  const canCreateApp = ApplicationsState.canCreateApplication.value

  return (
    <div className={`home-container ${canCreateApp ? 'create' : ''}`}>
      <ConvocatoriaContainer />
      <div className='home-actions'>
        <ApplicationsFilters />

        {OfflineState.isOnline.value && <ImportApplications />}

        {ConvocatoriasState.currentConvocatoria.value.id &&
          OfflineState.isOnline.value && (
            <Tooltip title='Exportar data de convocatoria' placement='left'>
              <Button
                className='refresh-btn'
                shape='circle'
                icon={<BiExport size={16} />}
                loading={ApplicationsState.loading.value.export}
                disabled={
                  ApplicationsState.loading.value.getAll ||
                  ApplicationsState.loading.value.export ||
                  OfflineState.isSynchronizing.value
                }
                onClick={applicationsStateActions.exportData}
              />
            </Tooltip>
          )}

        <Tooltip title='Actualizar lista de solicitudes' placement='left'>
          <Button
            className='refresh-btn'
            shape='circle'
            icon={<FiRefreshCw size={16} />}
            loading={ApplicationsState.loading.value.getAll}
            disabled={
              ApplicationsState.loading.value.getAll ||
              OfflineState.isSynchronizing.value
            }
            onClick={applicationsStateActions.getAllApplications}
          />
        </Tooltip>
      </div>
      <ApplicationsTable />
    </div>
  )
}
